export const DataResponsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1300 },
        items: 3
    },
    tablet: {
        breakpoint: { max: 1300, min: 890 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 890, min: 0 },
        items: 1
    }
};